"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
var _regeneratorRuntime2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _classCallCheck2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/createClass.js"));
var _callSuper2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/callSuper.js"));
var _inherits2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/inherits.js"));
var _defineProperty2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _SingleImage = _interopRequireDefault(require("@/components/Upload/SingleImage.vue"));
var _auth = require("@/utils/auth");
var _vuePropertyDecorator = require("vue-property-decorator");
var _product = require("@/types/product");
var _ProductModal = require("./ProductModal.vue");
var _vueBarcode = _interopRequireDefault(require("vue-barcode"));
var _shopeeProduct = require("@/api/shopeeProduct.api");
var _shopifyProduct = require("@/api/shopifyProduct.api");
var ProductInfoForm = /*#__PURE__*/function (_Vue) {
  function ProductInfoForm() {
    var _this;
    (0, _classCallCheck2.default)(this, ProductInfoForm);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = (0, _callSuper2.default)(this, ProductInfoForm, [].concat(args));
    (0, _defineProperty2.default)(_this, "form", void 0);
    (0, _defineProperty2.default)(_this, "rules", void 0);
    (0, _defineProperty2.default)(_this, "status", void 0);
    (0, _defineProperty2.default)(_this, "stores", void 0);
    (0, _defineProperty2.default)(_this, "categories", void 0);
    (0, _defineProperty2.default)(_this, "handleBlurOriginPrice", void 0);
    (0, _defineProperty2.default)(_this, "$refs", void 0);
    (0, _defineProperty2.default)(_this, "fileList", []);
    (0, _defineProperty2.default)(_this, "shopeeProducts", []);
    (0, _defineProperty2.default)(_this, "shopifyProducts", []);
    (0, _defineProperty2.default)(_this, "Unit", _product.Unit);
    (0, _defineProperty2.default)(_this, "UnitTrans", _product.UnitTrans);
    (0, _defineProperty2.default)(_this, "Shape", _product.Shape);
    (0, _defineProperty2.default)(_this, "renderBreadcrumb", _ProductModal.renderBreadcrumb);
    return _this;
  }
  (0, _inherits2.default)(ProductInfoForm, _Vue);
  return (0, _createClass2.default)(ProductInfoForm, [{
    key: "token",
    get: function get() {
      return (0, _auth.getToken)();
    }
  }, {
    key: "mounted",
    value: function mounted() {
      this.fetchShopeeProducts();
      this.fetchShopifyProducts();
    }
  }, {
    key: "fetchShopeeProducts",
    value: function () {
      var _fetchShopeeProducts = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var search,
          res,
          _args = arguments;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              search = _args.length > 0 && _args[0] !== undefined ? _args[0] : "";
              _context.next = 3;
              return _shopeeProduct.shopeeProductApi.findAll({
                page: 1,
                limit: 50,
                search: search
              });
            case 3:
              res = _context.sent;
              this.shopeeProducts = res.data.shopeeProducts;
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function fetchShopeeProducts() {
        return _fetchShopeeProducts.apply(this, arguments);
      }
      return fetchShopeeProducts;
    }()
  }, {
    key: "fetchShopifyProducts",
    value: function () {
      var _fetchShopifyProducts = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2() {
        var search,
          res,
          _args2 = arguments;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              search = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : "";
              _context2.next = 3;
              return _shopifyProduct.shopifyProductApi.findAll({
                page: 1,
                limit: 50,
                search: search
              });
            case 3:
              res = _context2.sent;
              this.shopifyProducts = res.data.shopifyProducts;
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function fetchShopifyProducts() {
        return _fetchShopifyProducts.apply(this, arguments);
      }
      return fetchShopifyProducts;
    }()
  }, {
    key: "uploadListSuccess",
    value: function uploadListSuccess(response, file, fileList) {
      debugger;
      this.$emit("upload:ok", {
        path: file.response.data.path,
        file: file,
        fileList: fileList
      });
      this.fileList = fileList;
    }
  }, {
    key: "handleRemove",
    value: function handleRemove(file, fileList) {
      this.$emit("delete", {
        file: file
      });
      this.fileList = fileList;
    }
  }]);
}(_vuePropertyDecorator.Vue);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], ProductInfoForm.prototype, "form", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], ProductInfoForm.prototype, "rules", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], ProductInfoForm.prototype, "status", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], ProductInfoForm.prototype, "stores", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], ProductInfoForm.prototype, "categories", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], ProductInfoForm.prototype, "handleBlurOriginPrice", void 0);
ProductInfoForm = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  components: {
    SingleImage: _SingleImage.default,
    barcode: _vueBarcode.default
  }
})], ProductInfoForm);
var _default = exports.default = ProductInfoForm;